import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { NotBlankGenericFieldValidator } from './not-blank-generic-field-validator'
import { ValidatedSelectOptionModel } from './validated-dropdown.component'
import { State } from '../common/models/state'
import * as _ from 'lodash'

@Component({
    selector: 'ValidatedStateDropdown',
    templateUrl: './html-templates/validated-state-dropdown.component.html'
})
export class ValidatedStateDropdown implements OnChanges, OnInit {
    undefinedState = { code: undefined } as unknown as State

    @Input()
    set selectedState(state: State) {
        if (state) {
            this.defaultSelectedState = state
        } else {
            this.defaultSelectedState = this.undefinedState
        }
    }

    get selectedState(): State {
        return this.defaultSelectedState
    }

    @Input() disabled = false
    @Input() states: State[]
    @Input() label: String = 'State'
    @Output() onValueChange = new EventEmitter<State>()

    notBlankValidator = new NotBlankGenericFieldValidator()
    defaultSelectedState: State = this.undefinedState
    stateOptions: ValidatedSelectOptionModel[]

    constructor() {}

    ngOnInit() {
        this.updateStates()
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateStates()
    }

    stateForCode(code: string): State {
        return _.find(this.states, (state: State) => state.code === code) || ({} as State)
    }

    private updateStates() {
        if (this.states) {
            this.getStateOptionsFromInput()
        }
    }

    private getStateOptionsFromInput() {
        this.stateOptions = _.orderBy(this.states.map(this.buildOptionFromState.bind(this)), 'text', 'asc')
    }

    private buildOptionFromState(state: State): ValidatedSelectOptionModel {
        return {
            value: state.code,
            text: state.name
        }
    }
}
